<template>
  <div class="content">
  <div style="background-color: #f9f9f9;height: 50px;text-align: left;padding-left:15px;margin-bottom: 15px;" v-if="tableData.approvalState =='Y' || tableData.approvalState =='R' || tableData.approvalState =='A' || tableData.approvalState =='N'">
     <p class="fl" v-if="bizState =='A' || bizState =='N'">提交审批时间：{{ApprovalTime}} <span class="mr15"></span> 提交人：{{operater}}</p>
     <p class="fl" v-if="bizState =='Y' || bizState =='R'">审批时间：{{ApprovalTime}}        审批结果：{{bizState | approvalState}}</p>
    <el-button size="small" class="fr mr15 mt10" type="info" @click="addStaffApprovalHist">审批记录</el-button>  
  </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="24">  
        <el-col :span="8"><div class="search-area-div1">月份：{{tableData.month || '-'}}</div> </el-col> 
         <el-col :span="8"><div class="search-area-div1">批次：{{tableData.batchNum || '-'}}</div> </el-col> 
        <el-col :span="8"><div class="search-area-div1">通知时间：{{tableData.noticeTime | getDate}}</div> </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8"><div class="search-area-div1">企业：{{tableData.tenantName || '-'}}</div> </el-col>
        <el-col :span="8"><div class="search-area-div1">推广费总额：{{tableData.totalAmount | numDigit | numFmt}}</div> </el-col> 
      </el-row> 
    </div> 
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
    <div class="w100f t-left mb15">
    <b>省总提报信息</b> 
    </div>
    <div class="button-area pd0"> 
            <el-button size="medium" type="info" class="fl" @click="performanceCheck" v-if="tableData.approvalState !='Y'">提交审批</el-button>  
            <!-- <el-button size="medium" type="primary">查看人员推广费明细</el-button> -->
            <el-button plain size="medium" @click="toDetailLink(tableData.guid)">查看人员推广费明细</el-button>
    </div>
      <el-table :data="tableData.performanceReportVOS" border style="width: 100%; margin-top: 15px;" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="organisationNames" label="组织(只到省区)" show-overflow-tooltip header-align="center" align="center">
                  <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="staffName" label="提报人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="positionNames" label="提报人岗位" header-align="center" align="center">
                    <template slot-scope="scope">{{ scope.row.positionNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="amount" label="提报金额(元)" show-overflow-tooltip header-align="center" align="right">
                    <template slot-scope="scope">{{scope.row.amount | numDigit | numFmt}}</template>
        </el-table-column>
        <el-table-column prop="reportPeopleNum" label="提报状态" header-align="center" align="center">
                    <template slot-scope="scope">
                          <div class="fontC-green" v-if="scope.row.reportPeopleNum >0">{{scope.row.reportPeopleNum > 0 ?'已提报':'待提报'}}</div>
                          <div v-else>{{scope.row.reportPeopleNum > 0 ?'已提报':'待提报'}}</div> 
                    </template>
        </el-table-column>
        <el-table-column prop="reportPeopleNum" label="提报人数" header-align="center" align="center">
                    <template slot-scope="scope">{{scope.row.reportPeopleNum==null?'-':scope.row.reportPeopleNum}}</template>
        </el-table-column> 
        <el-table-column prop="reportTime" label="提报时间" sortable header-align="center" align="center">
          <template slot-scope="scope">
                    <div v-if="scope.row.reportTime == null">-</div> 
                    <div v-else>{{scope.row.reportTime | getDate}}</div> 
          </template>
        </el-table-column> 
        <el-table-column prop="approvalState" label="审核状态" sortable header-align="center" align="center">
                    <template slot-scope="scope">
                        <div class="fontC-green" v-if="scope.row.approvalState == 'Y'">{{scope.row.approvalState | approvalState}}</div>
                        <div class="fontC-red" v-if="scope.row.approvalState == 'R'">{{scope.row.approvalState | approvalState}}</div>
                        <div v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'">{{scope.row.approvalState | approvalState}}</div>
                  </template>
        </el-table-column> 
        <el-table-column prop="approvalTime" label="审核时间" sortable header-align="center" align="center">
          <template slot-scope="scope">
                    <div v-if="scope.row.approvalTime == null ||  scope.row.approvalState == 'N' || scope.row.approvalState == 'A'">-</div> 
                    <div v-else>{{scope.row.approvalTime | getDate}}</div> 
                    </template>
        </el-table-column> 
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'" @click="toSubmit(scope.row.performanceReportGuid,scope.row.positionNames)">提报审核</a>
            <a class="txt-color" v-if="scope.row.approvalState == 'Y' || scope.row.approvalState == 'R'" @click="toDetail(scope.row.performanceReportGuid,scope.row.positionNames)">提报详情</a> 
            
          </template>
        </el-table-column>
      </el-table> 
      
    </div>   
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 30, 50]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   -->
    <el-drawer
      title="审批记录"
      :visible.sync="drawer"
      :with-header="true">
      <el-timeline :reverse="reverse">
          <el-timeline-item v-for="(activity, index) in getStaffApprovalHistList" :key="index" class="t-left">
            <p v-if="activity.approvalState =='A' || activity.approvalState =='N'">提交时间：{{activity.operateTime | getDate}}</p>
            <p v-if="activity.approvalState =='A' || activity.approvalState =='N'">提交人：{{activity.operater}}</p> 
            <p v-if="activity.approvalState =='Y' || activity.approvalState =='R'">审批时间：{{activity.operateTime | getDate}}</p>
            <p v-if="activity.approvalState =='Y' || activity.approvalState =='R'">审批结果：{{activity.approvalState | approvalState}}</p> 
            <p class="fontC-red" v-if="activity.approvalState =='R'">驳回原因：{{activity.approvalSuggest}}</p>
            <!-- <p v-if="activity.approvalState =='R'">审批建议：{{activity.approvalSuggest==null?'无':activity.approvalSuggest}}</p> -->
            <p v-if="activity.approvalState =='Y' || activity.approvalState =='R'">审批人：{{activity.operater}}</p> 
          </el-timeline-item>
        </el-timeline>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return { 
      page: {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      },
      tableData: [],  
      timeList:'',
      drawer: false, 
      reverse:false,
      getStaffApprovalHistList:[],
      ApprovalTime:'',
      bizState:'',
      operater:'',
      tableLoading:false,
      height:window.innerHeight - 440, 
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getStaffApprovalHist();
  }, 
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      };
      self.getData(true);
    }, 
    getData(flg) {
      let self = this; 
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-detail?`+`guid=`+self.$router.history.current.query.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },   
    addStaffApprovalHist(){
              let self = this; 
              self.drawer = true; 
              self.getStaffApprovalHist();
      },
      getStaffApprovalHist(){
              let self = this;  
              self.api.get(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-approval-hist?performanceGuid=`+self.$router.history.current.query.guid).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                      console.log(res.data);
                          self.getStaffApprovalHistList = res.data.data;
                          if(self.getStaffApprovalHistList[0].operateTime != null){
                                self.ApprovalTime = self.$moment(self.getStaffApprovalHistList[0].operateTime).format('YYYY-MM-DD HH:mm:ss');
                                self.bizState = self.getStaffApprovalHistList[0].approvalState; 
                                self.operater = self.getStaffApprovalHistList[0].operater;
                          }else{ 
                                self.ApprovalTime = '';
                                self.bizState = '';
                                self.operater = '';
                          }
                          
                          // console.log(self.bizState );
                     }else {
                      self.$message.error(res.msg);
                     } 
              }) 
      },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    }, 
    toSubmit(performanceReportGuid,positionNames){
          this.$router.push({path: "/submitForReview", query:{   productGuid:this.$route.query.productGuid,performanceReportGuid:performanceReportGuid,month:this.tableData.month,batchNum:this.tableData.batchNum,positionNames:positionNames,guid:this.$router.history.current.query.guid}})
    },
    toDetail(performanceReportGuid,positionNames){
      this.$router.push({path: "/submitForReviewDetail", query:{   productGuid:this.$route.query.productGuid,performanceReportGuid:performanceReportGuid,month:this.tableData.month,batchNum:this.tableData.batchNum,positionNames:positionNames,guid:this.$router.history.current.query.guid}})
    },
    toDetailLink(guid){
        this.$router.push({path: "/performanceDetailsAll", query:{   productGuid:this.$route.query.productGuid,guid:guid}})
    },
    performanceCheck(){
        let self = this;
         self.api.post(`/${serverConfig.msSalesPerformService}/performance/data/performance-check`,{'performanceGuid':self.$router.history.current.query.guid,tenantGuid:localStorage.guid}).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交审批成功！');
              self.$router.push({path: "/performanceReporting"})
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
  },
};
</script>
<style scoped>
.search-area-div1{
  text-align: left;
  margin-bottom: 10px;
}
</style>
